import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import {
  CurrencyType,
  GiftCardPlanService,
} from 'app/services/gift-cards-plans.service';
import {
  GiftCardsProductsActions,
  SubscriptionsProductsActions,
} from './products.actions';
import { PlansApi } from 'app/modules/dashboard/api/plans.api';

@Injectable()
export class ProductsEffects {
  private actions$: Actions = inject(Actions);
  private planApi: PlansApi = inject(PlansApi);
  private giftCardService: GiftCardPlanService = inject(GiftCardPlanService);

  loadSubscriptionsProductsInit$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SubscriptionsProductsActions.getSubscriptionsProducts),
      mergeMap((action) =>
        this.planApi.getAllPlans(action.currency).pipe(
          map((subscriptionsProducts) =>
            SubscriptionsProductsActions.setSubscriptionsProducts({
              subscriptionsProducts: subscriptionsProducts,
            })
          ),
          catchError(() =>
            of(
              SubscriptionsProductsActions.setSubscriptionsProducts({
                subscriptionsProducts: [],
              })
            )
          )
        )
      )
    );
  });

  loadGiftCardInit$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GiftCardsProductsActions.getGiftCardsProducts),
      mergeMap((action) =>
        this.giftCardService.getGiftCards(action.currency).pipe(
          map((giftCards) =>
            GiftCardsProductsActions.setGiftCardsProducts({
              giftCardsProducts: giftCards,
            })
          ),
          catchError(() =>
            of(
              GiftCardsProductsActions.setGiftCardsProducts({
                giftCardsProducts: [],
              })
            )
          )
        )
      )
    );
  });
}
